module.exports = __webpack_public_path__ + "static/media/Red_Failed.cecc973d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/confirmation/icons/Red_Failed.svg
// module id = 100
// module chunks = 0